const morocco = [
    { "code": "Tanger-Tetouan-Al Hoceima", "name": "Tanger-Tetouan-Al Hoceima" },
    { "code": "Oriental", "name": "Oriental" },
    { "code": "Fès-Meknès", "name": "Fès-Meknès" },
    { "code": "Rabat-Salé-Kénitra", "name": "Rabat-Salé-Kénitra" },
    { "code": "Béni Mellal-Khénifra", "name": "Béni Mellal-Khénifra" },
    { "code": "Casablanca-Settat", "name": "Casablanca-Settat" },
    { "code": "Marrakech-Safi", "name": "Marrakech-Safi" },
    { "code": "Drâa-Tafilalet", "name": "Drâa-Tafilalet" },
    { "code": "Souss-Massa", "name": "Souss-Massa" },
    { "code": "Guelmim-Oued Noun", "name": "Guelmim-Oued Noun" },
    { "code": "Laâyoune-Sakia El Hamra", "name": "Laâyoune-Sakia El Hamra" },
    { "code": "Dakhla-Oued Ed-Dahab", "name": "Dakhla-Oued Ed-Dahab" }
];
export default morocco;